import {
  StepProgress,
  StepProgressProps,
} from "components/StepProgress/StepProgress";
import { Tooltip } from "components/Tooltip/Tooltip";
import { ModalRunProgress } from "pages/gdt/modals/ModalRunProgress/ModalRunProgress";
import { DataTableStoreState } from "pages/gdt/store/DataTableProvider.types";
import { useModalContext } from "providers/ModalProvider/ModalProvider";
import { colorsByRunStatus } from "types/ColorsByRunStatus";
import { RunStatus, RunStepStatus } from "types/constants";

const statusToStep = (
  status: RunStepStatus | null,
): StepProgressProps["steps"][number] => {
  switch (status) {
    case null: {
      return "pending";
    }
    case RunStepStatus.NEW: {
      return "pending";
    }
    case RunStepStatus.RUNNING: {
      return "active";
    }
    case RunStepStatus.FAILED: {
      return "error";
    }
    case RunStepStatus.COMPLETE: {
      return "complete";
    }
  }
};

export interface RunProgressProps {
  row: {
    id: string;
    run: NonNullable<
      Extract<
        DataTableStoreState["tables"][number],
        { kind: "workflow" }
      >["rows"][number]["run"]
    >;
  };
}

export const RunProgress = ({ row }: RunProgressProps) => {
  const run = row.run;
  const { openModal: _openModal, closeModal } = useModalContext();
  const color = colorsByRunStatus[run.status];

  const tooltipContent = (
    <>
      <span style={{ color }}>{RunStepStatus[run.status]}</span>
      <br />
      View run details
    </>
  );
  const openModal = () =>
    _openModal(<ModalRunProgress rowId={row.id} onClose={closeModal} />);
  if (run.status === RunStatus["COMPLETE"]) {
    return (
      <Tooltip content={tooltipContent}>
        <StepProgress size="l" steps={["complete"]} onClick={openModal} />
      </Tooltip>
    );
  }
  if (run.status === RunStatus["FAILED"]) {
    return (
      <Tooltip content={tooltipContent}>
        <StepProgress size="l" steps={["error"]} onClick={openModal} />
      </Tooltip>
    );
  }
  return (
    <Tooltip content={tooltipContent}>
      <StepProgress
        size="l"
        steps={run.progress.nodes.map((n) => statusToStep(n.status ?? null))}
        onClick={openModal}
      />
    </Tooltip>
  );
};
